import React, { useState } from 'react';
import styles from './AcademicManager.module.css'; // Usaremos um novo CSS
import LibraryManager from './LibraryManager';
import MaterialProducer from './MaterialProducer';
import { useTranslation } from 'react-i18next';

function AcademicManager({ isSidebarOpen }) {
  const { t } = useTranslation();
  const [activeView, setActiveView] = useState('libraries'); // 'libraries' ou 'producer'

  return (
    <div className={`${styles.academicManager} ${!isSidebarOpen ? styles.adjustedForClosedSidebar : ''}`}>
      <div className={styles.academicHeader}>
        <h2 className={styles.academicManagerTitle}>{t('academic')}</h2>
        <div className={styles.headerSpacer}></div>
      </div>
      
      <div className={styles.academicManagerNavButtons}>
        <button
          className={`${styles.navButton} ${activeView === 'libraries' ? styles.navButtonActive : ''}`}
          onClick={() => setActiveView('libraries')}
        >
          {t('myLibraries')}
        </button>
        <button
          className={`${styles.navButton} ${activeView === 'producer' ? styles.navButtonActive : ''}`}
          onClick={() => setActiveView('producer')}
        >
          {t('materialProducer')}
        </button>
      </div>

      <div className={styles.contentArea}>
        {activeView === 'libraries' ? <LibraryManager /> : <MaterialProducer isSidebarOpen={isSidebarOpen} />}
      </div>
    </div>
  );
}

export default AcademicManager;